<template>
  <v-dialog max-width="60%" v-model="computed_dialog">
    <app-card>
      <h4>{{ chosen_repairman && chosen_repairman._id ? 'CHỈNH SỬA THÔNG TIN THỢ SỬA CHỮA' : 'THÊM THỢ SỬA CHỮA MỚI' }}
      </h4>
      <v-form ref="form">
        <v-container fluid>
          <v-layout row wrap>
            <v-flex xs12 md12>
              <v-text-field v-model="formData.name" label="Tên Thợ Sửa Chữa" :rules="[rules.required]" required
                :disabled="loading.submit" prepend-icon="person"></v-text-field>
            </v-flex>
            <v-flex xs12 md6>
              <v-text-field v-model.number="formData.daily_hours" label="Số Giờ Làm Việc Hàng Ngày"
                :rules="[rules.required, rules.number, rules.minAndMaxHours]" type="number" required
                :disabled="loading.submit" prepend-icon="access_time"></v-text-field>
            </v-flex>
            <v-flex xs12 md6>
              <v-text-field v-model.number="formData.daily_wage" label="Lương Ngày"
                :rules="[rules.required, rules.number, rules.minWage]" type="number" required :disabled="loading.submit"
                prepend-icon="money"></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :loading="loading.submit" :disabled="loading.submit" @click="handleSubmit" color="green"
            class="white--text">
            {{ chosen_repairman && chosen_repairman._id ? 'Cập nhật' : 'Tạo mới' }}
          </v-btn>
        </v-card-actions>
      </v-form>
    </app-card>
  </v-dialog>
</template>

<script>
import api from "Api";

export default {
  name: "DialogTaoThoSuaChua",
  props: {
    dialog: Boolean,
    chosen_repairman: Object,
    type: String
  },
  data() {
    return {
      computed_dialog: false,
      loading: {
        submit: false,
      },
      formData: {
        name: '',
        daily_hours: null,
        daily_wage: null,
        type: this.type
      },
      rules: {
        required: (value) => (value !== null && value !== undefined && value !== '') || 'Vui lòng điền thông tin này.',
        number: (value) => typeof value === 'number' && !isNaN(value) || 'Vui lòng nhập một số hợp lệ.',
        minAndMaxHours: (value) => value >= 0 && value <= 24 || 'Số giờ làm việc không thể âm hoặc quá 24 giờ',
        minWage: (value) => value >= 0 || 'Lương ngày không thể âm.',
      },
    };
  },
  watch: {
    dialog(nv) {
      this.computed_dialog = nv;
      if (nv && this.chosen_repairman && this.chosen_repairman._id) {
        this.formData = { ...this.chosen_repairman };
      } else {
        this.clearForm();
      }
    },
    computed_dialog(nv) {
      if (!nv) {
        this.$emit('changeDialogState', nv);
        this.clearForm();
      }
    },
  },
  methods: {
    clearForm() {
      if (this.$refs.form) {
        this.$refs.form.reset();
        this.$refs.form.resetValidation();
      }
      this.formData = {
        name: '',
        daily_hours: null,
        daily_wage: null,
        type: this.type
      };
    },
    async handleSubmit() {
      if (!this.$refs.form.validate()) {
        swal.fire('Lỗi', 'Vui lòng điền đầy đủ và chính xác thông tin', 'error');
        return;
      }

      this.loading.submit = true;
      try {
        let response;
        if (this.chosen_repairman && this.chosen_repairman._id) {
          response = await api.updateRepairman(this.chosen_repairman._id, { ...this.formData, type: this.type });
        } else {
          response = await api.createRepairman({ ...this.formData, type: this.type });
        }

        if (response.status === 200 || response.status === 201) {
          swal.fire('Thành công', response.data.message, 'success');
          this.computed_dialog = false;
          this.$emit('reloadTable');
        } else {
          swal.fire('Lỗi', response.message || 'Không thể lưu thông tin thợ sửa chữa', 'error');
        }
      } catch (err) {
        console.error('Lỗi khi lưu thông tin thợ sửa chữa:', err);
        swal.fire('Lỗi', err.message || 'Đã xảy ra lỗi khi lưu dữ liệu.', 'error');
      } finally {
        this.loading.submit = false;
      }
    },
  },
};
</script>

<style scoped>
.v-card-title {
  background-color: #e0f2f7;
  color: #263238;
  border-bottom: 1px solid #cfd8dc;
}

.v-btn.primary {
  background-color: #2196f3 !important;
  color: white !important;
}

.v-btn.grey {
  background-color: #9e9e9e !important;
  color: white !important;
}
</style>